import { render, staticRenderFns } from "./compToMore.vue?vue&type=template&id=2857f463&scoped=true&"
import script from "./compToMore.vue?vue&type=script&lang=js&"
export * from "./compToMore.vue?vue&type=script&lang=js&"
import style0 from "./compToMore.vue?vue&type=style&index=0&id=2857f463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857f463",
  null
  
)

export default component.exports